import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    kicker: "Show up",
    title: "On time, in uniform, ready to serve you.",
    body: "We believe in punctuality here at Peak Disposal — you can count on us to show up on time and ready to serve your every need!",
  },
  {
    n: "02",
    kicker: "No hiccups",
    title: "One crew, one goal.",
    body: "The same team that quotes the job works the job — start to finish. One point of contact, one clear plan, and one goal.",
  },
  {
    n: "03",
    kicker: "Leave it right",
    title: "Mi casa es su casa.",
    body: "After every service we do a complete walk-through to make sure we leave your home spotless, and in better shape than we found it! We only roll out when YOU are 100% satisfied with your service!",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="bg-white py-24 md:py-40 border-b border-navy/10" data-testid="manifesto-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-20">
          <div className="md:col-span-3" />
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="md:col-span-9 font-display font-black uppercase text-navy tracking-[-0.02em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            data-testid="manifesto-heading"
          >
            What you can expect from the <span className="italic font-medium text-navy pr-4">Handsome Men</span>in BLUE Polos.
          </motion.h2>
        </div>

        <div className="space-y-16 md:space-y-24">
          {chapters.map((c) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-navy pt-10"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="md:col-span-4">
                <div className="font-display font-black leading-none tracking-[-0.05em] text-[22vw] md:text-[10vw] lg:text-[9vw] text-navy">
                  {c.n}
                </div>
              </div>

              <div className="md:col-span-4 md:pt-2">
                <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-navy/60 mb-3">
                  {c.kicker}
                </div>
                <h3 className="font-display font-bold uppercase text-navy text-2xl md:text-3xl leading-tight tracking-tight">
                  {c.title}
                </h3>
              </div>

              <div className="md:col-span-4 md:pt-2">
                <p className="text-slate-600 leading-relaxed text-[15px] md:text-base max-w-md">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
